export default __webpack_public_path__ + "static/media/Dropoff_Number.460630c2.svg";